/**
 * BB Ring Size Guide — same conversion grid/data + overlay behavior as reference FYS
 */
(function () {
  /* Same half-size chart as reference (22 values) — keeps modal compact */
  const UNITS = {
    circumference_mm: {
      label: 'Circumference (mm)',
      values: ['44.2', '45.5', '46.8', '48.0', '49.3', '50.6', '51.9', '53.1', '54.4', '55.7', '57.0', '58.3', '59.5', '60.8', '62.1', '63.4', '64.6', '65.9', '67.2', '68.5', '69.7', '71.0'],
      us: ['3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13', '13.5'],
    },
    diameter_mm: {
      label: 'Diameter (mm)',
      values: ['14.1', '14.5', '14.9', '15.3', '15.7', '16.1', '16.5', '16.9', '17.3', '17.7', '18.1', '18.6', '18.9', '19.4', '19.8', '20.2', '20.6', '21.0', '21.4', '21.8', '22.2', '22.6'],
      us: ['3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13', '13.5'],
    },
    uk_au: {
      label: 'UK / Australia',
      values: ['F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'Z+1'],
      us: ['3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13', '13.5'],
    },
    eu: {
      label: 'EU',
      values: ['44', '45', '47', '48', '49', '50', '51', '53', '54', '55', '57', '58', '59', '60', '61', '63', '64', '65', '67', '68', '69', '71'],
      us: ['3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13', '13.5'],
    },
  };

  function formatSelectValue(usSize) {
    const n = parseFloat(usSize);
    if (Number.isNaN(n)) return String(usSize);
    return n.toFixed(2);
  }

  function applyToSelect(select, usSize) {
    if (!select || usSize == null || usSize === '' || usSize === '-') return false;
    const targetNum = parseFloat(usSize);
    const wanted = formatSelectValue(usSize);
    const options = Array.from(select.options).filter((o) => o.value !== '');

    let match = options.find((o) => o.value === wanted || o.textContent.trim() === wanted);
    if (!match && !Number.isNaN(targetNum)) {
      let best = null;
      let bestDiff = Infinity;
      options.forEach((o) => {
        const n = parseFloat(o.value);
        if (Number.isNaN(n)) return;
        const d = Math.abs(n - targetNum);
        if (d < bestDiff) {
          bestDiff = d;
          best = o;
        }
      });
      match = best;
    }
    if (!match) return false;
    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }

  class BbRingSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this._usSize = '';
      this._trigger = null;
      this._scrollLocked = false;

      this._box = this.querySelector('[data-rsg-dialog]');
      this._closeBtn = this.querySelector('[data-rsg-close-btn]');
      this._grid = this.querySelector('[data-rsg-grid]');
      this._unit = this.querySelector('[data-rsg-unit]');
      this._usBox = this.querySelector('[data-rsg-us-size]');
      this._gotIt = this.querySelector('[data-rsg-got-it]');

      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      this._onOverlayClick = (e) => {
        if (e.target === this) this.close();
      };
      this.addEventListener('click', this._onOverlayClick);

      this._onCloseBtn = (e) => {
        e.preventDefault();
        this.close();
      };
      this._closeBtn?.addEventListener('click', this._onCloseBtn);

      this.addEventListener('click', (e) => {
        const goto = e.target.closest('[data-rsg-goto]');
        if (goto && this.contains(goto)) {
          e.preventDefault();
          this.showStep(Number(goto.getAttribute('data-rsg-goto')));
          return;
        }

        const pdfBtn = e.target.closest('[data-rsg-pdf-download]');
        if (pdfBtn && this.contains(pdfBtn)) {
          e.preventDefault();
          this.downloadPdf(pdfBtn.getAttribute('data-rsg-pdf-download'));
          return;
        }

        const chip = e.target.closest('[data-rsg-chip]');
        if (chip && this._grid?.contains(chip)) {
          e.preventDefault();
          this.selectChip(chip);
          return;
        }

        if (e.target.closest('[data-rsg-got-it]')) {
          e.preventDefault();
          this.confirm();
        }
      });

      this._touchStartY = 0;
      this._box?.addEventListener(
        'touchstart',
        (e) => {
          this._touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );
      this._box?.addEventListener(
        'touchend',
        (e) => {
          const dy = e.changedTouches[0].clientY - this._touchStartY;
          if (dy > 80) this.close();
        },
        { passive: true }
      );

      this._unit?.addEventListener('change', () => {
        if (this._usBox) this._usBox.textContent = '-';
        this._usSize = '';
        this.renderGrid(this._unit.value);
      });

      this._onKey = (e) => {
        if (e.key === 'Escape' && !this.hasAttribute('hidden')) this.close();
      };
      document.addEventListener('keydown', this._onKey);

      this.renderGrid('circumference_mm');
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      this.removeEventListener('click', this._onOverlayClick);
      this._closeBtn?.removeEventListener('click', this._onCloseBtn);
      this.unlockScroll();
    }

    lockScroll() {
      if (this._scrollLocked) return;
      this._scrollLocked = true;
      // Theme pattern: compensates scrollbar so layout does not shift left
      document.body.classList.add('body-no-scrollbar');
    }

    unlockScroll() {
      if (!this._scrollLocked) return;
      this._scrollLocked = false;
      document.body.classList.remove('body-no-scrollbar');
    }

    open(trigger) {
      this._trigger = trigger || null;
      this.showStep(1);
      this.clearResult();
      this.removeAttribute('hidden');
      this.lockScroll();
      requestAnimationFrame(() => this._box?.focus?.({ preventScroll: true }));
    }

    close() {
      if (this.hasAttribute('hidden')) return;
      this.setAttribute('hidden', '');
      this.unlockScroll();
      const prev = this._trigger;
      this._trigger = null;
      prev?.focus?.({ preventScroll: true });
    }

    showStep(n) {
      this.querySelectorAll('[data-rsg-step]').forEach((step) => {
        const on = step.getAttribute('data-rsg-step') === String(n);
        step.classList.toggle('bb-rsg__step--hidden', !on);
      });
      if (n === 2) {
        this.renderGrid(this._unit ? this._unit.value : 'circumference_mm');
      }
    }

    clearResult() {
      this._usSize = '';
      if (this._usBox) this._usBox.textContent = '-';
      this._grid?.querySelectorAll('.bb-rsg__grid-item--selected').forEach((el) => {
        el.classList.remove('bb-rsg__grid-item--selected');
      });
    }

    renderGrid(unitKey) {
      if (!this._grid) return;
      const unit = UNITS[unitKey] || UNITS.circumference_mm;
      this._grid.innerHTML = '';
      unit.values.forEach((val, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bb-rsg__grid-item';
        btn.setAttribute('data-rsg-chip', '');
        btn.setAttribute('data-us', unit.us[i] || '');
        btn.textContent = val;
        this._grid.appendChild(btn);
      });
    }

    selectChip(chip) {
      this._grid.querySelectorAll('.bb-rsg__grid-item').forEach((el) => {
        el.classList.toggle('bb-rsg__grid-item--selected', el === chip);
      });
      this._usSize = (chip.getAttribute('data-us') || '').trim();
      if (this._usBox) this._usBox.textContent = this._usSize || '-';
    }

    downloadPdf(url) {
      if (!url) return;
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'RING_SIZE.pdf';
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            URL.revokeObjectURL(a.href);
            a.remove();
          }, 1000);
        })
        .catch(() => {
          window.open(url, '_blank');
        });
    }

    confirm() {
      const selectId = this.getAttribute('data-select-id');
      const select = selectId ? document.getElementById(selectId) : null;
      if (this._usSize) applyToSelect(select, this._usSize);
      this.close();
    }
  }

  if (!customElements.get('bb-ring-size-guide')) {
    customElements.define('bb-ring-size-guide', BbRingSizeGuide);
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-rsg-open]');
    if (!trigger) return;
    e.preventDefault();
    const guideId = trigger.getAttribute('data-rsg-open');
    const guide = guideId ? document.getElementById(guideId) : null;
    if (guide && typeof guide.open === 'function') guide.open(trigger);
  });
})();
